import { render, staticRenderFns } from "./MenuItemIconInner.vue?vue&type=template&id=74e97578&"
import script from "./MenuItemIconInner.vue?vue&type=script&setup=true&lang=js&"
export * from "./MenuItemIconInner.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports